import DownloadIcon from "@mui/icons-material/Download"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import CircularProgress from "@mui/material/CircularProgress"
import FormControl from "@mui/material/FormControl"
import FormHelperText from "@mui/material/FormHelperText"
import IconButton from "@mui/material/IconButton"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Modal from "@mui/material/Modal"
import Select from "@mui/material/Select"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import environment from "../environment"
import { Game } from "../models/game"

interface DownloadGhostProps {
  game: Game
  trackId: number
  playerId: string
}

export default function DownloadGhost(props: DownloadGhostProps) {
  const { game, trackId, playerId } = props
  const [open, setOpen] = useState(false)
  const [ghostType, setGhostType] = useState("dg")
  const [slotId, setSlotId] = useState("00")
  const [downloading, setDownloading] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const handleGhostType = (event: any) => {
    setGhostType(event.target.value)
  }
  const handleSlotId = (event: any) => {
    setSlotId(event.target.value)
  }

  const downloadGhost = () => {
    setDownloading(true)
    fetch(`${environment.domain}/api/${game}/ghost?tid=${trackId}&pid=${playerId}&gt=${ghostType}&sid=${slotId}`)
      .then(async (response) => {
        const blob = await response.blob()
        const filename = response.headers.get("Filename")
        if (blob && filename) {
          const link = document.createElement("a")
          link.href = URL.createObjectURL(blob)
          link.download = filename
          link.click()
          handleClose()
        }
      })
      .finally(() => {
        setDownloading(false)
      })
  }

  return (
    <div>
      {/* TODO: Implement download icon */}
      {/* <IconButton
        size="small"
        sx={{ height: "36px", width: "36px" }}
        onClick={handleOpen}
      >
        <DownloadIcon></DownloadIcon>
      </IconButton> */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ backdropFilter: "blur(1px)" }}
      >
        <Box
          sx={(theme) => ({
            backgroundColor: theme.palette.background.paper,
            border: "1px solid rgba(127, 127, 127, 0.5)",
            borderRadius: "5px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 450,
            p: 4,
          })}
        >
          <Typography variant="h6" component="h2">
            Download Ghost
          </Typography>
          <FormControl sx={{ mt: 2 }} fullWidth size="small">
            <InputLabel>Ghost Type</InputLabel>
            <Select
              value={ghostType}
              label="Ghost Type"
              onChange={handleGhostType}
            >
              <MenuItem value={"gs"}>gs: Player's Own Record</MenuItem>
              <MenuItem value={"sg"}>sg: Staff Ghost</MenuItem>
              <MenuItem value={"dg"}>dg: Downloaded Ghost</MenuItem>
            </Select>
          </FormControl>
          {ghostType === "dg" && (
            <FormControl sx={{ mt: 2 }} fullWidth size="small">
              <InputLabel>Order Id</InputLabel>
              <Select value={slotId} label="Order Id" onChange={handleSlotId}>
                <MenuItem value={"00"}>00</MenuItem>
                <MenuItem value={"01"}>01</MenuItem>
                <MenuItem value={"02"}>02</MenuItem>
                <MenuItem value={"03"}>03</MenuItem>
                <MenuItem value={"04"}>04</MenuItem>
                <MenuItem value={"05"}>05</MenuItem>
                <MenuItem value={"06"}>06</MenuItem>
                <MenuItem value={"07"}>07</MenuItem>
                <MenuItem value={"08"}>08</MenuItem>
                <MenuItem value={"09"}>09</MenuItem>
                <MenuItem value={"0a"}>0a</MenuItem>
                <MenuItem value={"0b"}>0b</MenuItem>
                <MenuItem value={"0c"}>0c</MenuItem>
                <MenuItem value={"0d"}>0d</MenuItem>
                <MenuItem value={"0e"}>0e</MenuItem>
                <MenuItem value={"0f"}>0f</MenuItem>
              </Select>
              <FormHelperText>
                The slot address out of the available 16 slots.
              </FormHelperText>
            </FormControl>
          )}
          <Button
            variant="contained"
            sx={{ mt: 2, width: "100%" }}
            disabled={downloading}
            startIcon={
              downloading ? (
                <CircularProgress
                  sx={{ color: "rgba(255, 255, 255, 0.3)" }}
                  size={20}
                />
              ) : (
                <DownloadIcon></DownloadIcon>
              )
            }
            onClick={downloadGhost}
          >
            Download
          </Button>
          <FormHelperText sx={{ mt: 2 }}>
            Note: Your game must be running on Ver. 4.0+ for this ghost to run.
          </FormHelperText>
        </Box>
      </Modal>
    </div>
  )
}
